export function SearchEmailAddressModalCtrl ($uibModalInstance, $scope, $translate, emails) {
  $scope.emails = [];
  $scope.selectedItems = [];

  angular.forEach(emails, function (email) {
    $scope.emails.push({ email: email });
  });

  $scope.tableSettings = {
    columns: [
      {
        field : 'email',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.EMAIL_ADDRESS')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_EMAILS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      enabled: true
    },
    static: true
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.emails.filter((email) => email.selected);
    $scope.allSelected = $scope.selectedItems.length == $scope.emails.length;
  };

  $scope.selectAll = function () {
    $scope.allSelected = !$scope.allSelected;

    angular.forEach($scope.emails, function (email) {
      email.selected = $scope.allSelected;
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.add = function () {
    $uibModalInstance.close($scope.selectedItems);
  };
}
